import { combineReducers } from 'redux';

import Auth from './Auth/Auth.reducer.js';
import Agent from './Agent/Agent.reducer.js';
import Phone from './Phone/Phone.reducer.js';
import Deals from './Deals/deals.reducer.js';
import Payment from './Payment/Payment.reducer.js';
import Settings from './Settings/Settings.reducer.js';
import Campaign from './Campaign/Campaign.reducer.js';
import Assistant from './Assistant/Assistant.reducer.js';
import Integration from './Integration/Integration.reducer.js';
import Activities from './Activities/Activities.reducer.js';
import SinglePage from './SinglePage/singlepage.reducer.js';
import Objects from './Objects/objects.reducer.js';
import Workflows from './Workflows/workflows.reducer.js';
import Admin from './Admin/Admin.reducer.js';
import Analytics from './Dashboard/Dashboard.reducer.js';
import Notification from './Notification/Notification.reducer.js';

export default combineReducers({ Auth, Campaign, Integration, Agent, Phone, Settings, Payment, Assistant, Deals, Activities, SinglePage, Objects, Workflows, Admin, Analytics, Notification });